"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStreakDataFromActiveDates = exports.getDayActivitiesForListOfTimeZoneAgnosticDays = exports.StreakDayState = void 0;
const majime_1 = require("@drops-developers/majime");
var StreakDayState;
(function (StreakDayState) {
    StreakDayState["Future"] = "Future";
    StreakDayState["TodayActive"] = "TodayActive";
    StreakDayState["TodayInactive"] = "TodayInactive";
    StreakDayState["TodayCanSave"] = "TodayCanSave";
    StreakDayState["PendingYesterday"] = "PendingYesterday";
    StreakDayState["Active"] = "Active";
    StreakDayState["Skipped"] = "Skipped";
    StreakDayState["StreakSaved"] = "StreakSaved";
})(StreakDayState = exports.StreakDayState || (exports.StreakDayState = {}));
(function (StreakDayState) {
    StreakDayState.isCountedForCurrentStreak = (state) => [StreakDayState.TodayActive, StreakDayState.Active, StreakDayState.StreakSaved].includes(state);
    StreakDayState.isIgnoredForCurrentStreak = (state) => [StreakDayState.TodayInactive, StreakDayState.PendingYesterday, StreakDayState.TodayCanSave, StreakDayState.Future].includes(state);
    StreakDayState.isCountedForPrevoiusStreakRecord = (state) => [StreakDayState.Active, StreakDayState.StreakSaved].includes(state);
    StreakDayState.isIgnoredForPreviouosStreakRecord = (state) => [StreakDayState.TodayActive, StreakDayState.Active, StreakDayState.StreakSaved, StreakDayState.TodayInactive, StreakDayState.PendingYesterday, StreakDayState.TodayCanSave, StreakDayState.Future].includes(state);
})(StreakDayState = exports.StreakDayState || (exports.StreakDayState = {}));
const getDayActivitiesForListOfTimeZoneAgnosticDays = (activeDays, baseListOfDates, today, yesterday, dayBeforeYesterday) => {
    return baseListOfDates
        .map((day) => {
        if (day > today) {
            return { day, state: StreakDayState.Future };
        }
        if (day === today) {
            if (activeDays.has(today)) {
                return { day, state: StreakDayState.TodayActive, isFirstActiveDayInStreak: !activeDays.has(yesterday) && !activeDays.has(dayBeforeYesterday), isLastActiveDayInStreak: true };
            }
            if (activeDays.has(yesterday)) {
                return { day, state: StreakDayState.TodayInactive };
            }
            if (activeDays.has(dayBeforeYesterday)) {
                return { day, state: StreakDayState.TodayCanSave };
            }
            return { day, state: StreakDayState.TodayInactive };
        }
        if (day === yesterday) {
            if (activeDays.has(yesterday)) {
                const threeDaysAgo = majime_1.getPreviousTimeZoneAgnosticDay(dayBeforeYesterday);
                return { day, state: StreakDayState.Active, isFirstActiveDayInStreak: !activeDays.has(dayBeforeYesterday) && !activeDays.has(threeDaysAgo), isLastActiveDayInStreak: !activeDays.has(today) };
            }
            if (activeDays.has(dayBeforeYesterday)) {
                if (activeDays.has(today)) {
                    return { day, state: StreakDayState.StreakSaved };
                }
                else {
                    return { day, state: StreakDayState.PendingYesterday };
                }
            }
            return { day, state: StreakDayState.Skipped };
        }
        const previousDay = majime_1.getPreviousTimeZoneAgnosticDay(day);
        const dayBeforePreviousDay = majime_1.getPreviousTimeZoneAgnosticDay(previousDay);
        const followingDay = majime_1.getFollowingTimeZoneAgnosticDay(day);
        const dayAfterFollowingDay = majime_1.getFollowingTimeZoneAgnosticDay(followingDay);
        if (activeDays.has(day)) {
            return { day, state: StreakDayState.Active, isFirstActiveDayInStreak: !activeDays.has(previousDay) && !activeDays.has(dayBeforePreviousDay), isLastActiveDayInStreak: !activeDays.has(followingDay) && !activeDays.has(dayAfterFollowingDay) };
        }
        if (activeDays.has(previousDay) && activeDays.has(followingDay)) {
            return { day, state: StreakDayState.StreakSaved };
        }
        return { day, state: StreakDayState.Skipped };
    })
        .sortedByProperty((dayAndState) => dayAndState.day);
};
exports.getDayActivitiesForListOfTimeZoneAgnosticDays = getDayActivitiesForListOfTimeZoneAgnosticDays;
const getCurrentStreakFromDayStates = (allDateStates) => {
    const mostRecentActiveDays = allDateStates
        .filter((dayAndState) => !StreakDayState.isIgnoredForCurrentStreak(dayAndState.state))
        .takeWhile((dayAndState) => StreakDayState.isCountedForCurrentStreak(dayAndState.state), true);
    return mostRecentActiveDays.length;
};
const getPreviousStreakRecordFromDayStates = (allDateStates) => {
    const previousStreaks = allDateStates
        .skipWhile((dayAndState) => StreakDayState.isIgnoredForPreviouosStreakRecord(dayAndState.state), true);
    const maximumFindResult = previousStreaks.reduceRight((accum, item) => {
        if (StreakDayState.isCountedForPrevoiusStreakRecord(item.state)) {
            const currentStreak = accum.currentStreak + 1;
            return {
                currentStreak,
                maximumStreak: currentStreak > accum.maximumStreak ? currentStreak : accum.maximumStreak,
            };
        }
        else {
            return {
                currentStreak: 0,
                maximumStreak: accum.maximumStreak,
            };
        }
    }, {
        currentStreak: 0,
        maximumStreak: 0,
    });
    return maximumFindResult.maximumStreak;
};
const getDayStatesFromTimeZoneAgnosticDays = (activeDays) => {
    if (activeDays.length === 0) {
        return [];
    }
    const today = majime_1.getTimezoneAgnosticDayFromDate(new Date());
    const yesterday = majime_1.getPreviousTimeZoneAgnosticDay(today);
    const twoDaysAgo = majime_1.getPreviousTimeZoneAgnosticDay(yesterday);
    const tomorrow = majime_1.getFollowingTimeZoneAgnosticDay(today);
    const allDates = majime_1.getTimeZoneAgnosticDatesBetweenDates(activeDays.sorted().firstElement(), tomorrow);
    return exports.getDayActivitiesForListOfTimeZoneAgnosticDays(new Set(activeDays), allDates, today, yesterday, twoDaysAgo);
};
const getStreakDataFromActiveDates = (activeDays) => {
    const dayStates = getDayStatesFromTimeZoneAgnosticDays(activeDays);
    const currentStreak = getCurrentStreakFromDayStates(dayStates);
    const previousRecord = getPreviousStreakRecordFromDayStates(dayStates);
    return {
        currentStreak,
        previousRecord,
        record: Math.max(currentStreak, previousRecord),
    };
};
exports.getStreakDataFromActiveDates = getStreakDataFromActiveDates;
